export default __webpack_public_path__ + "static/media/search.65da7a3e.svg";